import React, { useState } from "react";
import Styles from "./styles.module.scss";
import DrawerHeader from "../DrawerHeader/DrawerHeader";
import T from "i18n-react";
import Button from "../Button";
import { useSelector } from "react-redux";
import { PostCodeValidator } from "../../../utils/PostCodeValidator";
import { checkPostCodeInDeliveryRadius } from "../../../utils/checkPostCodeInDeliveryRadius";
import PostCodeAlert from "./PostCodeAlert/PostCodeAlert";
import AddressForm from "../AddressForm/AddressForm";

export enum postcodeCheckStatusType {
  InDeliveryRadius = "InDeliveryRadius",
  OutOfDeliveryRadius = "OutOfDeliveryRadius",
  PostCodeInValid = "PostCodeInValid",
}

interface IPostCodeCheckerProps {
  closeDrawer: () => void;
  goToMenuPage: () => void;
}

function PostCodeChecker({ closeDrawer, goToMenuPage }: IPostCodeCheckerProps) {
  const [userSavedAddress, setUserSavedAddress] = useState<DeliveryAddressType>(
    {
      full_name: "",
      address: "",
      city: "",
      postcode: "",
    }
  );
  const [postcodeCheckStatus, setPostcodeCheckStatus] = useState<
    postcodeCheckStatusType
  >(null);
  const [postcodeCheckButtonLoading, setPostcodeCheckButtonLoading] = useState<
    boolean
  >(false);
  const Venue = useSelector((state: any) => state.Venue);

  // useEffect(() => {
  //   if (window.localStorage.getItem("BillingAddress")) {
  //     let address;
  //     if (typeof window.localStorage.getItem("BillingAddress") !== "object") {
  //       address = JSON.parse(window.localStorage.getItem("BillingAddress"));
  //     } else {
  //       address = window.localStorage.getItem("BillingAddress");
  //     }
  //     setUserSavedAddress(address);
  //     setPostCode(address ?.postcode);
  //   } else {
  //     setUserSavedAddress({
  //       full_name: "",
  //       address: "",
  //       city: "",
  //       postcode: "",
  //     });
  //   }
  // }, []);

  const handleDeliveryDetailsChange = (
    deliveryDetails: DeliveryAddressType
  ) => {
    setUserSavedAddress(deliveryDetails);
    if (deliveryDetails.postcode) {
      validatePostCode(deliveryDetails.postcode);
    }
    console.log("====================================");
    console.log(userSavedAddress);
    console.log("====================================");
  };

  const validatePostCode = (value) => {
    console.log("====================================");
    console.log(value);
    console.log("====================================");
    if (value.length > 2) {
      const postCodeValid = PostCodeValidator(value);
      if (postCodeValid) {
        setPostcodeCheckStatus(null);
        return true;
      }
    }
    setPostcodeCheckStatus(postcodeCheckStatusType.PostCodeInValid);
    return false;
  };

  async function checkPostCode() {
    // TO DO: move this logic into a reuseable component

    if (validatePostCode(userSavedAddress.postcode)) {
      setPostcodeCheckButtonLoading(true);
      const deliveryAddress = `${Venue.address_country}, ${userSavedAddress.address}, ${userSavedAddress.city}, ${userSavedAddress.postcode}`;
      try {
        await checkPostCodeInDeliveryRadius(
          Venue,
          deliveryAddress,
          Venue.delivery_radius_km,
          afterResponseFunction
        );
      } catch (error) {
        setPostcodeCheckButtonLoading(false);
      }
    }
  }

  function afterResponseFunction(InRadius) {
    if (InRadius) {
      setPostcodeCheckStatus(postcodeCheckStatusType.InDeliveryRadius);
      window.localStorage.setItem(
        "BillingAddress",
        JSON.stringify(userSavedAddress)
      );
      setTimeout(() => {
        closeDrawer();
        goToMenuPage();
      }, 1000);
    } else {
      setPostcodeCheckStatus(postcodeCheckStatusType.OutOfDeliveryRadius);
      setPostcodeCheckButtonLoading(false);
    }
  }

  return (
    <div className={Styles.PostCodeChecker}>
      <DrawerHeader
        title={T.translate("Forms.EnterAddress") as string}
        closeDrawer={closeDrawer}
      />

      <div className={Styles.PostCodeCheckerContent}>
        <p className={Styles.Description}>
          {T.translate("Venue.AddressDescription")}
        </p>
        <AddressForm
          handleDeliveryInfoChange={handleDeliveryDetailsChange}
          setPostCodeChanged={() => null}
          noFullName={true}
        />
        {/* <T.p
          className={Styles.PostCodeText}
          text={{ key: `Forms.EnterPostcodeText` }}
        />
        <div>
          <input
            id="postal"
            type="text"
            className={Styles.PostCodeInput}
            placeholder={T.translate("Forms.PostCode") as string}
            value={postCode}
            autoComplete="postal code"
            name="post_code"
            onChange={handleInputChange}
            onBlur={validatePostCode}
          />
        </div> */}
        <div
          style={{
            minHeight: "80px",
            marginBottom: "2.2rem",
          }}
        >
          <PostCodeAlert postcodeCheckStatus={postcodeCheckStatus} />
        </div>
        <div>
          <Button
            isYoelloBtn
            title="CheckPostCode"
            onClick={checkPostCode}
            isLoading={postcodeCheckButtonLoading}
          />
        </div>
      </div>
    </div>
  );
}

export default PostCodeChecker;
